<template>
  <div
    class="form-checkbox"
    :class="{'checked': checked, 'rounded': rounded, 'loading': loading}"
    :data-qa="dataQa"
    @click.stop="toggleCheck"
  >
    <svg-icon
      v-if="loading"
      icon="SvgLoading"
      :data-qa="`${dataQa}_loading_icon`"
    />
  </div>
</template>

<script>
export default {
  name: 'FormCheckbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: null
    }
  },
  methods: {
    toggleCheck () {
      if (this.loading) {
        return;
      }
      this.$emit('change', !this.checked);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
